import { triggerMouseflowTracking } from "@/features/analytics/triggers";

export const trackDqErrorShown = (screen: string) => {
  triggerMouseflowTracking({
    event: `dq_error_${screen.replaceAll("-", "_")}`,
  });
};
